import { inject, Injectable } from '@angular/core';
import { ConfirmDialogService } from 'src/app/dialogs';

@Injectable()
export class PrinterNavigationStateService {

  private readonly confirmDialogService = inject(ConfirmDialogService);

  private _initialData: any = null;
  get initialData(): any {
    return this._initialData
  }
  set initialData(value: any) {
    this._initialData = value;
  }

  private _isInternalItemChange: boolean = false;
  get isInternalItemChange(): boolean {
    return this._isInternalItemChange
  }
  set isInternalItemChange(value: boolean) {
    this._isInternalItemChange = value;
  }

  private checkInProgress = false;

  private currentChecker: (() => boolean) | null = null;

  register(fn: () => boolean) {
    this.currentChecker = fn;
  }

  unregister() {
    this.currentChecker = null;
  }

  hasUnsavedChanges(): boolean {
    return this.currentChecker ? this.currentChecker() : false;
  }

  async checkPendingData() {
    if(this.checkInProgress) return false;

    if (this.hasUnsavedChanges()) {
      this.checkInProgress = true;
      try {
        const confirmed = await this.confirmDialogService.openDialog({
          data: {
            messageLabel: 'PRINTERS.DETAIL.EDIT_CANCEL_CONFIRM',
            confirmLabel: 'APPLICATION.YES',
            cancelLabel: 'APPLICATION.NO',
            disableClose: true
          }
        });
  
        if(!confirmed) {
          this.isInternalItemChange = true;
          return false;
        }
      } finally {
        this.checkInProgress = false;
      }
    }
    return true;
  }

  checkChanges(currentData: any): boolean {
    if (!this.initialData || !currentData) return false;
    if(currentData.hasOwnProperty('value')) currentData = currentData.getRawValue();
    const equal = this.arePrintersEqual(this.initialData, currentData);
    return !equal;
  }

  private arePrintersEqual(a: any, b: any): boolean {
    // console.log("arePrintersEqual ", a, b)
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    
    return keys.every(key => this.arePrintersEqual(a[key], b[key]));
  }
}
